import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'organization' }) => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Prabhat Tara Vidya Niketan",
    "alternateName": [
      "PTVN Goraul",
      "No. 1 Private School in Goraul",
      "No. 1 School in Goraul",
      "No. 1 School Near Goraul",
      "No. 1 Private School in Goraul Vaishali",
      "No. 1 School in Goraul Vaishali",
      "No. 1 School Near Goraul Vaishali",
      "Best Private School in Goraul",
      "Best School in Goraul Vaishali",
      "Best School Near Goraul"
    ],
    "url": "https://prabhattaravidyaniketan.in",
    "logo": "https://prabhattaravidyaniketan.in/images/logo.jpg",
    "description": "Prabhat Tara Vidya Niketan is widely recognized as the No. 1 private school in Goraul, Vaishali with 30+ years of educational excellence, affiliated with Bihar Government, providing holistic education from Nursery to Class 10.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rajkhand, Block - Goraul",
      "addressLocality": "Vaishali",
      "addressRegion": "Bihar",
      "postalCode": "844114",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7654164726",
      "contactType": "Admissions & Campus Office",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61562571579177",
      "https://www.instagram.com/prabhattaravidyaniketan/",
      "https://www.youtube.com/@ptvn_goraul",
      "https://www.google.com/maps/place/Prabhat+Tara+Vidya+Niketan+Goraul/@25.9272702,85.3309645,783m/data=!3m2!1e3!4b1!4m6!3m5!1s0x39ed6b88a06921db:0x62a848a0ca5eb38b!8m2!3d25.9272702!4d85.3309645!16s%2Fg%2F11fd6c0c96"
    ],
    "founder": {
      "@type": "Person",
      "name": "Shubh Nath Singh"
    },
    "foundingDate": "1995",
    "numberOfStudents": {
      "@type": "QuantitativeValue",
      "value": "1200+"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://prabhattaravidyaniketan.in/"
      }
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Prabhat Tara Vidya Niketan",
    "alternateName": "No. 1 Private School in Goraul",
    "url": "https://prabhattaravidyaniketan.in"
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "School",
    "name": "Prabhat Tara Vidya Niketan",
    "alternateName": [
      "PTVN Goraul",
      "No. 1 School in Goraul",
      "No. 1 Private School in Goraul",
      "No. 1 School Near Goraul",
      "No. 1 Private School in Goraul Vaishali",
      "No. 1 School in Goraul Vaishali",
      "No. 1 School Near Goraul Vaishali",
      "Best School in Goraul",
      "Best Private School in Goraul Vaishali",
      "Best School Near Goraul"
    ],
    "image": "https://prabhattaravidyaniketan.in/descriptive-image/school-building-front-view.jpg",
    "@id": "https://prabhattaravidyaniketan.in",
    "url": "https://prabhattaravidyaniketan.in",
    "telephone": "+91-7654164726",
    "priceRange": "₹₹",
    "description": "Ranked the No. 1 private school in Goraul, Vaishali with 30+ years of academic excellence, Bihar Government affiliation, Nursery to Class 10 admissions, smart digital labs, and safe campus transport.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rajkhand, Goraul",
      "addressLocality": "Vaishali",
      "addressRegion": "Bihar",
      "postalCode": "844114",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 25.9272702,
      "longitude": 85.3309645
    },
    "hasMap": "https://www.google.com/maps/place/Prabhat+Tara+Vidya+Niketan+Goraul/@25.9272702,85.3309645,783m/data=!3m2!1e3!4b1!4m6!3m5!1s0x39ed6b88a06921db:0x62a848a0ca5eb38b!8m2!3d25.9272702!4d85.3309645!16s%2Fg%2F11fd6c0c96",
    "areaServed": [
      "Goraul",
      "Vaishali",
      "Rajkhand",
      "Bhagwanpur",
      "Mahua",
      "Chehrakalan",
      "Saraiya",
      "Sondho",
      "Enayatpur"
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "08:00",
      "closes": "15:30"
    }
  };

  const homeFaqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Which is the No. 1 private school in Goraul, Vaishali?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prabhat Tara Vidya Niketan (PTVN), located in Rajkhand, Goraul, is recognized as the No. 1 private school in Goraul and Vaishali district. Established in 1995, it boasts 30+ years of educational excellence, 100% board examination pass rates, modern science and computer labs, smart ScanScore assessment, and an experienced teaching faculty from Nursery to Class 10."
        }
      },
      {
        "@type": "Question",
        "name": "Which is the No. 1 school near Goraul for Nursery to Class 10?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prabhat Tara Vidya Niketan is the No. 1 school near Goraul, serving students from Rajkhand, Sondho, Bhagwanpur, Mahua, Chehrakalan, and surrounding villages with dedicated, safe school transport and a peaceful, distraction-free campus."
        }
      },
      {
        "@type": "Question",
        "name": "Which is the best private school in Goraul, Vaishali?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prabhat Tara Vidya Niketan (PTVN) is regarded by parents and educators as the best private school in Goraul, Vaishali due to its student-centric care, 100% board exam results, computer training, and holistic sports and cultural programs."
        }
      },
      {
        "@type": "Question",
        "name": "What is the fee structure at the No. 1 private school in Goraul Vaishali?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prabhat Tara Vidya Niketan provides an affordable, completely transparent fee schedule with zero hidden charges or mandatory donations. Fees can be paid in flexible monthly or quarterly installments, and sibling concessions are available."
        }
      },
      {
        "@type": "Question",
        "name": "Is school bus transport available in and around Goraul?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Prabhat Tara Vidya Niketan operates a safe, supervised transport network covering Goraul Bazaar, Rajkhand, Sondho, Enayatpur, Bhagwanpur border, and connecting junctions."
        }
      },
      {
        "@type": "Question",
        "name": "How can I apply for admission at Prabhat Tara Vidya Niketan Goraul?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Parents can apply online at prabhattaravidyaniketan.in/admission-enquiry or visit the school admissions counter in Rajkhand, Goraul during working hours (Monday to Saturday, 8:00 AM to 3:30 PM). For instant guidance, call +91-7654164726 or +91-9939988606."
        }
      }
    ]
  };

  const getSchemas = () => {
    switch (type) {
      case 'home':
        return [organizationSchema, websiteSchema, localBusinessSchema, breadcrumbSchema, homeFaqSchema];
      case 'breadcrumb':
        return [breadcrumbSchema];
      default:
        return [organizationSchema];
    }
  };

  return (
    <Helmet>
      {getSchemas().map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
